require("@polleverywhere/toolkit/lib/foreman_env.js.erb")
PollEv.env.set({
  
  slides_server_url: 'PLACEHOLDER_SLIDES_SERVER_URL_PLACEHOLDER',
  

  

  
  google_tag_manager_id: 'PLACEHOLDER_GOOGLE_TAG_MANAGER_ID_PLACEHOLDER',
  

  
  participant_embed_url: 'PLACEHOLDER_PARTICIPANT_EMBED_URL_PLACEHOLDER',
  

  
  viz_embed_url: "PLACEHOLDER_EMBED_URL_PLACEHOLDER",
  

  
  folders_feedback_survey_participant_key: "PLACEHOLDER_FOLDERS_FEEDBACK_SURVEY_PARTICIPANT_KEY_PLACEHOLDER",
  

  
  folder_nesting_limit: "PLACEHOLDER_FOLDER_NESTING_LIMIT_PLACEHOLDER",
  

  
  __no_comma: true
})
